import { therapistDisciplineList } from 'src/redux/actions/constant';

const { GET_THERAPIST_DISCIPLINE_LIST_FAILURE, GET_THERAPIST_DISCIPLINE_LIST_SUCCESS } =
  therapistDisciplineList;

const intialState: object = {
  response: null,
  isError: false,
};

export const getAllDisciplineTherapistReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case GET_THERAPIST_DISCIPLINE_LIST_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isError: false,
      };
    }
    case GET_THERAPIST_DISCIPLINE_LIST_FAILURE: {
      return {
        ...state,
        response: action.payload,
        isError: true,
      };
    }

    default:
      return state;
  }
};
